/*
 * Copyright © 2015-2019 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import DispatchMappingsDetailsPanel from './layout';

export default connect()(DispatchMappingsDetailsPanel);
